import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestAttachmentPost = {
    path: "/attachments/:id",
    method: RouteHttpVerb.POST
};
export { locationRestAttachmentPost };
